import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import { ShellHost } from "./Pages/Shellhost";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import Geocode from "react-geocode";
import dotenv from "dotenv";
import "./Static/css/loading.override.css";
import "./Static/scss/_variables.scss";
import { BrowserRouter as Router } from "react-router-dom";
import "moment/locale/pt-br";

dotenv.config();

export const history = createBrowserHistory();

Geocode.setApiKey(process.env.REACT_APP_API_GOOGLE_KEY || "");
Geocode.setLanguage("pt-BR");

const root = document.getElementById("root") as HTMLElement;

ReactDOM.render(
  <Router>
    <ShellHost />
  </Router>,
  root
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA 
serviceWorker.register();
